import React from 'react';

const Message = ({chat, user}) => (
    <li className={`chat ${user === chat.username ? "right" : "left"}`}>
        {/* {user !== chat.username
             && 
             <img src={chat.img} alt={`${chat.username}'s profile pic`} />
        } */}

        {user === chat.username ? <li style={{fontStyle:'italic', fontSize:'10px', marginBottom:'4px', float:'right', marginLeft: '5px', color:'#ffffff'}}>{chat.username}</li> 
                                        : <li style={{fontStyle:'italic', fontSize:'10px', marginBottom:'4px', float:'left', color:'#ffffff'}}>{chat.username}</li>}

        {/* <br></br><li style={{wordBreak: 'break-all'}}>{chat.content}</li> */}
        {/* <br></br><li style={{wordBreak: 'break-word'}}>{chat.content}</li> */}
        <br></br><li>{chat.content}</li>

        {user === chat.username ? <li style={{fontStyle:'italic', fontSize:'10px', marginTop:'6px', float:'left', marginRight: '5px', color:'#ffffff'}}>{chat.timestamp}</li> 
                                        : <li style={{fontStyle:'italic', fontSize:'10px', marginTop:'6px', float:'right', color:'#ffffff'}}>{chat.timestamp}</li>}
    </li>
);

export default Message;